import React, { lazy } from "react";

// MUI Icons
import EventIcon from "@mui/icons-material/Event";
import SearchIcon from "@mui/icons-material/Search";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Groups3Icon from "@mui/icons-material/Groups3";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SchoolIcon from "@mui/icons-material/School";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import FilterFramesIcon from "@mui/icons-material/FilterFrames";
import SubjectIcon from "@mui/icons-material/Subject";
import ArticleIcon from "@mui/icons-material/Article";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import LanguageIcon from "@mui/icons-material/Language";
import DiscountIcon from "@mui/icons-material/Discount";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HelpIcon from "@mui/icons-material/Help";
import SummarizeIcon from "@mui/icons-material/Summarize";
import QuizIcon from "@mui/icons-material/Quiz";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import PaymentsIcon from '@mui/icons-material/Payments';

import StudentWatchingHours from "pages/StudentManagement/Students/StudentWatchingHours";
import StudentCourseTestReport from "pages/StudentManagement/Students/StudentCourseTestReport";
import AffiliateBillingDetails from "pages/BillingManagement/AffiliateBillingDetails";
import BalancePaymentReport from "pages/BillingManagement/BalancePaymentReport";
import UpdateBalancePayment from "pages/BillingManagement/UpdateBalancePayment";
import PGMaster from "pages/PGManagement/PGMaster";
import AddPGMaster from "pages/PGManagement/AddPGMaster";
import EditPGMaster from "pages/PGManagement/EditPGMaster";
import AffiliatePG from "pages/PGManagement/AffiliatePG";
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import BlogCategory from "pages/BlogManagement/BlogCategory/BlogCategory";
import Posts from "pages/BlogManagement/Posts/Posts";
import PostComments from "pages/BlogManagement/Posts/PostComments/PostComments";
import AddPost from "pages/BlogManagement/Posts/AddPost";
import UpdatePost from "pages/BlogManagement/Posts/UpdatePost";
import SamplePage from "pages/Sample/Sample";
import BulkUnEnrollmentPage from "pages/UnEnrollment/BulkTabUnEnrollment";
import PostalCourseDocFiles from "pages/CourseManagement/MapPostalDocuments/PostalCourseDocFiles";
import RejectedRefunds from "pages/PaymentRefundManagement/PaymentRefundLinks/RejectedRefunds";
import ExceptionalMobileCourses from "pages/StudentManagement/Students/ExceptionalMobileCourses";
import SpecialLectureAccess from "pages/StudentManagement/Students/SpecialLectureAccess";
import StudentPersonalizedLectures from "pages/StudentManagement/Students/StudentPersonalizedLectures";
import PersonalizedLectureAccessByCourse from "pages/StudentManagement/Students/PersonalizedLectureAccessbyCourse";
import StudentPersonalizedLecturesbyCourse from "pages/StudentManagement/Students/StudentPersonalizedLecturesbyCourse";
import ViewQuizs from "pages/DailyQuiz/ViewQuizs";
import AddQuiz from "pages/DailyQuiz/AddQuiz";
import StudentList from "pages/StudentManagement/Students/StudentList";

const Dashboard = lazy(() => import("pages/Dashboard/Dashboard"));
const ChangePassword = lazy(() =>
  import("pages/ChangePassword/ChangePassword")
);



// ----------------------- Course Management -----------------------//
const UpdateCourseCategory = lazy(() =>
  import("pages/CourseManagement/CourseCategory/UpdateCourseCategory")
);
const SingleCourseCategory = lazy(() =>
  import("pages/CourseManagement/CourseCategory/SingleCourseCategory")
);
const AddCourse = lazy(() =>
  import("pages/CourseManagement/Courses/AddCourse")
);
const SingleBillingCourse = lazy(() =>
  import("pages/CourseManagement/BillingCourse/SingleBillingCourse")
);
const UpdateCourse = lazy(() =>
  import("pages/CourseManagement/Courses/UpdateCourse")
);
const UpdateBillingCourse = lazy(() =>
  import("pages/CourseManagement/BillingCourse/UpdateBillingCourse")
);
// const WelcomeEmail = lazy(() =>
//   import("pages/CourseManagement/BillingCourse/WelcomeEmail")
// );
const WelcomeEmail = lazy(() =>
  import("pages/CourseManagement/BillingCourse/welcomeEmail/WelcomeEmail")
);
const DetailVideoMapping = lazy(() =>
  import("pages/CourseManagement/BillingCourse/Mapping/DetailVideoMapping")
);
const RecommendedCoursesMapping = lazy(() =>
  import(
    "pages/CourseManagement/BillingCourse/Mapping/RecommendedCoursesMapping"
  )
);
const DemoLectureMapping = lazy(() =>
  import("pages/CourseManagement/BillingCourse/Mapping/DemoLectureMapping")
);
const FaqMapping = lazy(() =>
  import("pages/CourseManagement/BillingCourse/Mapping/FaqMapping")
);
const CoreTakeAwayMapping = lazy(() =>
  import("pages/CourseManagement/BillingCourse/Mapping/CoreTakeAwayMapping")
);
const CoursePlatformMapping = lazy(() =>
  import("pages/CourseManagement/BillingCourse/Mapping/CoursePlatformMapping")
);
const ViewMappedSubject = lazy(() =>
  import("pages/CourseManagement/SubjectMapping/ViewMappedSubject")
);

const CourseMapping = lazy(() =>
  import("pages/CourseManagement/CourseMapping/CourseMapping")
);

const CourseMentors = lazy(() =>
  import("pages/CourseManagement/MentorsCourses/CourseMentors")
);

const AssignedMentors = lazy(() =>
  import("pages/CourseManagement/MentorsCourses/Sub/AssignedMentors")
);

const HumanitesCourses = lazy(() =>
  import("pages/CourseManagement/HumanitiesCourses/HumanitesCourses")
);
const AddHumanitiesCourses = lazy(() =>
  import("pages/CourseManagement/HumanitiesCourses/sub/AddHumanitiesCourses")
);
const EditHumanitiesCourses = lazy(() =>
  import("pages/CourseManagement/HumanitiesCourses/sub/EditHumanitiesCourses")
);



// **************************** Billing Management ************************************
const StudentAdmission = lazy(() =>
  import("pages/BillingManagement/StudentAdmission")
);
const NewStudentAdmission = lazy(() =>
  import("pages/BillingManagement/NewStudentAdmission")
);


const StudentDetails = lazy(() =>
  import("pages/BillingManagement/StudentDetails")
);

const BillingTransactionPendingReport = lazy(() =>
  import("pages/BillingManagement/BillingTransactionPendingReport")
);

const GSTReport = lazy(() => import("pages/BillingManagement/GSTReport"));
const ViewBillingCourses = lazy(() =>
  import("pages/CourseManagement/BillingCourse/ViewBillingCourses")
);
const IOSBillingCourse = lazy(() =>
  import("pages/CourseManagement/BillingCourse/IOSBillingCourse")
);
const AddBillingCourse = lazy(() =>
  import("pages/CourseManagement/BillingCourse/AddBillingCourse")
);
const ViewCourseCategory = lazy(() =>
  import("pages/CourseManagement/CourseCategory/ViewCourseCategory")
);
const AddCourseCategory = lazy(() =>
  import("pages/CourseManagement/CourseCategory/AddCourseCategory")
);
const ViewSubCategories = lazy(() =>
  import("pages/CourseManagement/CourseSubCategory/ViewSubCategories")
);

const ViewSubCategoryPlatform = lazy(() =>
  import(
    "pages/CourseManagement/SubCategoryPlatformManagement/ViewSubCategoryPlatform"
  )
);

const ViewGPSCourses = lazy(() =>
  import("pages/CourseManagement/GPSEnabledCourses/ViewGPSCourses")
);
const AddGPSCourse = lazy(() =>
  import("pages/CourseManagement/GPSEnabledCourses/AddGPSCourse")
);
const ViewGPSAccessStudent = lazy(() =>
  import("pages/CourseManagement/GPSAccessStudent/ViewGPSAccessStudent")
);
const GPSAccessStudentList = lazy(() =>
  import("pages/CourseManagement/GPSAccessStudent/GPSAccessStudentList")
);
const UpdateGPSCourse = lazy(() =>
  import("pages/CourseManagement/GPSEnabledCourses/UpdateGPSCourse")
);
const SingleGPSCourse = lazy(() =>
  import("pages/CourseManagement/GPSEnabledCourses/SingleGPSCourse")
);

const CoursePlatform = lazy(() =>
  import("pages/CourseManagement/Courses/CoursePlatform")
);
const SpecialExceptionalCourses = lazy(() =>
  import("pages/CourseManagement/SpecialExceptionalCourses/SpecialExceptionalCourses")
);
const SpecialExceptionStudents = lazy(() =>
  import("pages/CourseManagement/SpecialExceptionalCourses/SpecialExceptionStudents")
);
const SpecialExceptionalAccess = lazy(() =>
  import("pages/CourseManagement/SpecialExceptionalAccess/SpecialExceptionalAccessList")
);
const CoursesLectures = lazy(() =>
  import("pages/CourseManagement/Courses/CoursesLectures")
);
const ViewCourses = lazy(() =>
  import("pages/CourseManagement/Courses/ViewCourses")
);
const CourseSectionList = lazy(() =>
  import("pages/CourseManagement/Courses/CourseSection/CourseSectionList")
);
const CourseLectureList = lazy(() =>
  import("pages/CourseManagement/Courses/CourseLectures/CourseLectureList")
);

const SectionLectureList = lazy(() =>
  import("pages/CourseManagement/Courses/CourseSection/MapSectionLecture")
);
const MapPostalDocumentsList = lazy(() =>
  import("pages/CourseManagement/MapPostalDocuments/MapPostalDocumentsList")
);
const DeletedPostalDocuments = lazy(() =>
  import("pages/CourseManagement/MapPostalDocuments/DeletedPostalDocuments")
);

// ************************************ course Enquiry ***********************************
const CourseEnquiry = lazy(() =>
  import("pages/CourseManagement/CourseEnquiry/CourseEnquiryList")
);

const ViewSubjects = lazy(() =>
  import("pages/SubjectManagement/Subject/ViewSubjects")
);

const EvaluationPricing = lazy(() =>
  import("pages/CourseManagement/EvaluationPricing/EvaluationPricing")
);
const MobileNumber = lazy(() =>
  import("pages/StudentManagement/Students/MobileVerification/VerifyMobile")
);

// ----------------------- Student Management -----------------------//
const ViewStudents = lazy(() =>
  import("pages/StudentManagement/Students/ViewStudents")
);
const ViewTabCourseAccess = lazy(() =>
  import("pages/StudentManagement/WebsiteAccessToTab/ViewTabCourseAccess")
);
const AddTabCourseAccess = lazy(() =>
  import("pages/StudentManagement/WebsiteAccessToTab/AddTabCourseAccess")
);
const ViewLiveLectureAccess = lazy(() =>
  import("pages/StudentManagement/LiveLectureAccess/ViewLiveLectureAccess")
);
const AddLiveLectureAccess = lazy(() =>
  import("pages/StudentManagement/LiveLectureAccess/AddLiveLectureAccess")
);
const ViewTabLectureAccess = lazy(() =>
  import(
    "pages/StudentManagement/TabLectureDownloadAccess/ViewTabLectureAccess"
  )
);
const AddTabLectureAccess = lazy(() =>
  import("pages/StudentManagement/TabLectureDownloadAccess/AddTabLectureAccess")
);
const SingleStudent = lazy(() =>
  import("pages/StudentManagement/Students/SingleStudent")
);
const CourseWiseStudent = lazy(() =>
  import("pages/StudentManagement/CourseWiseStudent/CourseWiseStudent")
);

const CreateUserProfile = lazy(() =>
  import("pages/StudentManagement/CreateStudentProfile/UserProfile")
);

const UpdateUserProfile = lazy(() =>
  import("pages/StudentManagement/UpdateStudentProfile/UpdateStudentProfile")
);

const ViewStudentProfile = lazy(() =>
  import("pages/StudentManagement/UpdateStudentProfile/ViewProfile")
);

const SMStudentDetails = lazy(() =>
  import("pages/StudentManagement/StudentDetails/StudentDetails")
);

const OnDemandStudentDetails = lazy(() =>
  import("pages/StudentManagement/OnDemandStudentDetails/OnDemandStudentDetails")
);

const UpgradeStudentCourse = lazy(() =>
  import("pages/StudentManagement/UpgradeCourse/UpgradeStudentCourse")
);

const UpdateIFHStudent = lazy(() =>
  import("pages/StudentManagement/IFHStudents/UpdateIFHStudents")
);
const ViewSubSubjects = lazy(() =>
  import("pages/SubjectManagement/SubSubject/ViewSubSubject")
);

// ----------------------- Lecture Management -----------------------//
const ViewLectures = lazy(() => import("pages/LectureManagement/ViewLecture"));
const AddLecture = lazy(() => import("pages/LectureManagement/AddLecture"));
const UpdateLecture = lazy(() =>
  import("pages/LectureManagement/UpdateLecture")
);

// ----------------------- Staff Management -----------------------//
const AddStaff = lazy(() => import("pages/StaffManagement/AddStaff"));
const SingleStaff = lazy(() => import("pages/StaffManagement/SingleStaff"));
const UpdateStaff = lazy(() => import("pages/StaffManagement/UpdateStaff"));
const ViewStaffs = lazy(() => import("pages/StaffManagement/ViewStaffs"));

// ----------------------- Test Management -----------------------//
const AllTestListing = lazy(() =>
  import("pages/TestManagement/AllTest/AllTestListing")
);
const AddTest = lazy(() => import("pages/TestManagement/AllTest/AddTest"));
const UpdateTest = lazy(() =>
  import("pages/TestManagement/AllTest/UpdateTest")
);
const QuestionList = lazy(() =>
  import("pages/TestManagement/AllTest/QuestionSheet/QuestionList")
);

const AddQuestion = lazy(() =>
  import("pages/TestManagement/AllTest/QuestionSheet/AddQuestion")
);
const UpdateQuestion = lazy(() =>
  import("pages/TestManagement/AllTest/QuestionSheet/UpdateQuestion")
);
const TestBankListing = lazy(() =>
  import("pages/TestManagement/ArtifactBank/TestBankListing")
);
const MapTestToCourses = lazy(() =>
  import("pages/TestManagement/MapTestToCourses/MapTestToCourses")
);
const ArtifactMappingList = lazy(() =>
  import("pages/TestManagement/ArtifactMapping/ArtifactMappingList")
);

// ----------------------- Coupon Management -----------------------//
const ViewCoupons = lazy(() => import("pages/CouponManagement/ViewCoupons"));
const AddCoupon = lazy(() => import("pages/CouponManagement/AddCoupon"));
const UpdateCoupon = lazy(() => import("pages/CouponManagement/UpdateCoupon"));

// ----------------------- Master Bank -----------------------//
const ViewWebsiteVideoBank = lazy(() =>
  import("pages/MasterBank/WebsiteVideoBank/ViewVideoBank")
);
const AddWebsiteVideoBank = lazy(() =>
  import("pages/MasterBank/WebsiteVideoBank/AddVideoBank")
);
const UpdateWebsiteVideoBank = lazy(() =>
  import("pages/MasterBank/WebsiteVideoBank/UpdateVideoBank")
);

const ViewFaqs = lazy(() => import("pages/MasterBank/Faqs/ViewFaqs"));
const AddFaqs = lazy(() => import("pages/MasterBank/Faqs/AddFaqs"));
const UpdateFaqs = lazy(() => import("pages/MasterBank/Faqs/UpdateFaq"));

const ViewCoreTakeaway = lazy(() =>
  import("pages/MasterBank/CoreTakeAway/ViewCoreTakeaway")
);
const AddCoreTakeaway = lazy(() =>
  import("pages/MasterBank/CoreTakeAway/AddCoreTakeaway")
);
const UpdateCoreTakeaway = lazy(() =>
  import("pages/MasterBank/CoreTakeAway/UpdateCoreTakeaway")
);

// ----------------------- Help & Support -----------------------//
const ViewHelps = lazy(() => import("pages/Support/Help/ViewHelp"));
const ViewContact = lazy(() => import("pages/Support/Contact/ViewContact"));

// ----------------------- Live Lectures -----------------------//
const ViewLiveLectures = lazy(() =>
  import("pages/LiveLectures/ViewLiveLectures")
);
const AddLiveLecture = lazy(() => import("pages/LiveLectures/AddLiveLecture"));
const UpdateLiveLecture = lazy(() =>
  import("pages/LiveLectures/UpdateLiveLecture")
);

// ----------------------- Group Meetings -----------------------//
const ViewGroupMeetings = lazy(() =>
  import("pages/GroupMeetings/ViewGroupMeetings")
);
const AddGroupMeeting = lazy(() =>
  import("pages/GroupMeetings/AddGroupMeeting")
);
const UpdateGroupMeeting = lazy(() =>
  import("pages/GroupMeetings/UpdateGroupMeeting")
);

// ----------------------- Daily Quiz -----------------------//
const UpdateQuiz = lazy(() => import("pages/DailyQuiz/UpdateQuiz"));

// ----------------------- Notification -----------------------//
const ViewNotifications = lazy(() =>
  import("pages/NotificationManagement/ViewNotifications")
);
const AddNotification = lazy(() =>
  import("pages/NotificationManagement/AddNotification")
);

// ----------------------- Evaluation Summary -----------------------//
const EvaluationSummary = lazy(() =>
  import("pages/Evaluation/EvaluationSummary/EvaluationSummary")
);
const ModeratorBestCopies = lazy(() =>
  import("pages/Evaluation/ModeratorBestCopies/ModeratorBestCopies")
);
const BestCopies = lazy(() => import("pages/Evaluation/BestCopies/BestCopies"));
const UploadAnswerSheet = lazy(() =>
  import("pages/Evaluation/UploadAnswerSheet/UploadAnswerSheet")
);
const EvaluatorDashboard = lazy(() =>
  import("pages/Evaluation/EvaluatorDashboard/EvaluatorDashboard")
);
const CoordinatorDashboard = lazy(() =>
  import("pages/Evaluation/CoordinatorDashboard/CoordinatorDashboard")
);
const EvaluatorBilling = lazy(() =>
  import("pages/Evaluation/EvaluatorBilling/EvaluatorBilling")
);

// ----------------------- Permissions -----------------------//
const Permissions = lazy(() => import("pages/Permissions/permission"));

const AddKnoxTabletStudents = lazy(() =>
  import("pages/Permissions/AddKnoxTabletStudents")
);

const AffiliateMacId = lazy(() =>
  import("pages/Reports/LectureReport/AffiliateMacId")
);

const OldStudentList = lazy(() =>
  import("pages/StudentManagement/Students/OldStudentList")
);

const AddOldStudentDetail = lazy(() =>
  import("pages/StudentManagement/Students/AddOldStudentDetails")
);

const CourseAccessReport = lazy(() =>
  import("pages/Reports/CourseAccessReport/CourseAccessReport")
);

const PSIRTestStudents = lazy(() =>
  import("pages/PSIRTestStudents/PSIRTestStudents")
);
const StudentCountByTest = lazy(() =>
  import("pages/StudentReports/StudentCountByTest")
);
const StudentAttendanceCountReport = lazy(() =>
  import("pages/StudentReports/StudentAttendanceCountReport")
);
const StudentDetailsReport = lazy(() =>
  import("pages/StudentReports/StudentDetailsReport")
);
const StudentAttendanceReport = lazy(() =>
  import("pages/StudentReports/StudentAttendanceReport")
);
// ************************************* KYC Mangement ********************************************

const StudentKYCDetails = lazy(() =>
  import("pages/KYCManagement/StudentKYCDetails")
);
const VerifiedKYCList = lazy(() =>
  import("pages/KYCManagement/VerifiedKYCList")
);
const KYCVerifiedByStudentList = lazy(() =>
  import("pages/KYCManagement/KYCVerifiedByStudentList")
);
const RequestedKYCList = lazy(() =>
  import("pages/KYCManagement/RequestedKYCList")
);
const StudentKYCAction = lazy(() =>
  import("pages/KYCManagement/StudentKYCAction")
);

//************************************ Exceptional Lecture Management ********************************
const ExceptionalLectures = lazy(() =>
  import("pages/ExceptionalLectureManagement/ExceptionalLectures")
);


//************************************ Folder Management ********************************
const FolderList = lazy(() =>
  import("pages/FolderManagement/FolderList")
);


//************************************ Payment Management ********************************
const PaymentLinkList = lazy(() =>
  import("pages/Payments/PaymentLinks/PaymentLinkList")
);
const SendPaymentLink = lazy(() =>
  import("pages/Payments/SendPaymentLink/SendPaymentLink")
);

//************************************ Payment Refund Management ********************************
const SendPaymentRefundLink = lazy(() =>
  import("pages/PaymentRefundManagement/SendPaymentRefundLink/SendPaymentRefundLink")
);
const PaymentRefundLinks = lazy(() =>
  import("pages/PaymentRefundManagement/PaymentRefundLinks/PaymentRefundLinks")
);
const ApprovePaymentRefunds = lazy(() =>
  import("pages/PaymentRefundManagement/PaymentRefundLinks/sub/ApprovePaymentRefunds")
);
const ProceedRefundPayment = lazy(() =>
  import("pages/PaymentRefundManagement/PaymentRefundLinks/sub/ProceedRefundPayment")
);

const TabUnEnrollmentList = lazy(() =>
  import("pages/UnEnrollment/TabUnEnrollmentList")
);
const UnEnrolledTabsList = lazy(() =>
  import("pages/UnEnrollment/UnEnrolledTabsList")
);


//************************************ Menu Access Management ********************************
const MenuList = lazy(() =>
  import("pages/MenuAccessManagement/Mwnu/MenuList")
);
const AssignedMenus = lazy(() =>
  import("pages/MenuAccessManagement/AssignedMenus/AssignedMenus")
);
const AssignedMenu = lazy(() =>
  import("pages/MenuAccessManagement/AssignMenu/AssignedMenu")
);



export const sidebar = (roles = []) => {
  const sidebarData = [
    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "Dashboard",
      icon: <DashboardIcon fontSize="small" />,
      path: "/dashboard",
      isChild: null,
    },

    {
      id: 110000,
      enabled: roles.includes(110000),
      name: "Manage Staff",
      icon: <Groups3Icon fontSize="small" />,
      path: "/staff-management",
      isChild: null,
    },

    // ************************************ Menu Access Management **************************************
    {
      id: 777124,
      enabled: roles.includes(777124),
      name: "Menu Management",
      icon: <LinearScaleIcon fontSize="small" />,
      path: "/menu-access-management",
      isChild: [
        {
          id: 777125,
          enabled: roles.includes(777125),
          name: "Menus",
          path: "/menu-access-management/menu",
        },
        {
          id: 777126,
          enabled: roles.includes(777126),
          name: "Assigned Menus",
          path: "/menu-access-management/assigned-menus",
        },
        {
          id: 777127,
          enabled: roles.includes(777127),
          name: "Assign Menu",
          path: "/menu-access-management/assign-menu",
        },
      ]
    },

    {
      id: 120000,
      enabled: roles.includes(120000),
      name: "Course Management",
      icon: <MenuBookIcon fontSize="small" />,
      path: "/course-management",
      isChild: [
        {
          id: 120200,
          enabled: roles.includes(120200),
          name: "All Courses",
          path: "/course-management/courses",
        },

        {
          id: 120300,
          enabled: roles.includes(120300),
          name: "Course Category",
          path: "/course-management/course-category",
        },
        {
          id: 120400,
          enabled: roles.includes(120400),
          name: "Course Sub-Category",
          path: "/course-management/course-sub-category",
        },
        {
          id: 120700,
          enabled: roles.includes(120700),
          name: "Map Subject To Course",
          path: "/course-management/map-course",
        },

        // {
        //   id: 120812,
        //   enabled: roles.includes(120200),
        //   name: "Student Courses Enquiry",
        //   path: "/course-management/course-enquiry",
        // },
      ],
    },
    {
      id: 130000,
      enabled: roles.includes(130000),
      name: "Student Management",
      icon: <SchoolIcon fontSize="small" />,
      path: "/student-management",
      isChild: [
        {
          id: 130100,
          enabled: roles.includes(130100),
          name: "Student Assign Course",
          path: "/student-management/assign-course",
        },
        {
          id: 130112,
          enabled: roles.includes(130112),
          name: "All Students List",
          path: "/student-management/all-student-list",
        },
        // {
        //   id: 130107,
        //   enabled: roles.includes(130107),
        //   name: "Mobile Course Access",
        //   path: "/student-management/exceptional-mobile-courses",
        // },
        // {
        //   id: 130108,
        //   enabled: roles.includes(130108),
        //   name: "Personalized Lecture Access",
        //   path: "/student-management/personalized-lecture-access",
        // },

        // {
        //   id: 130109,
        //   enabled: roles.includes(130109),
        //   name: "Student Personalized Lectures",
        //   path: "/student-management/student-personalized-lectures",
        // },
        // {
        //   id: 130111,
        //   enabled: roles.includes(130111),
        //   name: "Personalized Lecture Access by course",
        //   path: "/student-management/personalized-lecture-access-by-course",
        // },
        // {
        //   id: 130110,
        //   enabled: roles.includes(130110),
        //   name: "Student Personalized Lectures by course",
        //   path: "/student-management/student-personalized-lectures-by-course",
        // },
        // {
        //   id: 130106,
        //   enabled: roles.includes(130106),
        //   name: "Upgrade Course",
        //   path: "/student-management/upgrade-course",
        // },
        {
          id: 120116,
          enabled: roles.includes(120116),
          name: "Student Details",
          path: "/student-management/student-details",
        },
        // {
        //   id: 852369,
        //   enabled: roles.includes(852369),
        //   name: "Add IFH Students",
        //   path: "/student-management/add-ifh-students",
        // },
        // {
        //   id: 120116,
        //   enabled: roles.includes(120116),
        //   name: "On Demand Student Details",
        //   path: "/student-management/on-demand-student-details",
        // },
        // {
        //   id: 564812,
        //   enabled: roles.includes(564812),
        //   name: "GPS Courses Student List",
        //   path: "/student-management/gps-courses-student-list",
        // },
        {
          id: 130200,
          enabled: roles.includes(130200),
          name: "Course Wise Student",
          path: "/student-management/course-wise-student",
        },
        // {
        //   id: 130300,
        //   // enabled: roles.includes(130300),
        //   enabled: false,
        //   name: "Website Access to tab Course",
        //   path: "/student-management/tab-course-access",
        // },
        // {
        //   id: 130400,
        //   // enabled: roles.includes(130400),
        //   enabled: false,
        //   name: "Live Lecture Access on website",
        //   path: "/student-management/live-lecture-access",
        // },
        // {
        //   id: 130500,
        //   enabled: roles.includes(130500),
        //   name: "TAB-Lecture Download Access",
        //   path: "/student-management/tab-lecture-download-access",
        // },
        {
          id: 652480,
          enabled: roles.includes(652480),
          name: "Create student profile",
          path: "/student-management/create-student-profile",
        },
        {
          id: 130600,
          enabled: roles.includes(130600),
          name: "Update student profile",
          path: "/student-management/update-profile",
        },
        // {
        //   id: 5124896,
        //   enabled: roles.includes(5124896),
        //   name: "Student Course Test Report",
        //   path: "/student-course-test-report",
        // },
        // {
        //   id: 9658546,
        //   enabled: false,
        //   name: "Verify Mobile Number",
        //   path: "/verify-mobile",
        // },
      ],
    },
    {
      id: 140000,
      enabled: roles.includes(140000),
      name: "Test Bank Management",
      icon: <HistoryEduIcon fontSize="small" />,
      path: "/test-management",
      isChild: [
        {
          id: 140100,
          enabled: roles.includes(140100),
          name: "All Test",
          path: "/test-management/test",
        },
        // {
        //   id: 140200,
        //   enabled: roles.includes(140200),
        //   name: "Artifacts Bank",
        //   path: "/test-management/test-bank",
        // },
        // {
        //   id: 140300,
        //   enabled: roles.includes(140300),
        //   name: "Artifacts Mapping",
        //   path: "/test-management/artifacts-mapping",
        // },
        {
          id: 140400,
          enabled: roles.includes(140400),
          name: "Map Tests to Courses",
          path: "/test-management/map-test-to-courses",
        },
      ],
    },
    {
      id: 310000,
      enabled: roles.includes(310000),
      name: "Evaluation",
      icon: <PlaylistAddCheckCircleIcon fontSize="small" />,
      path: "/evaluation-management",
      isChild: [
        {
          id: 310100,
          enabled: roles.includes(310100),
          name: "Evaluation Summary",
          path: "/evaluation-management/evaluation-summary",
        },
      ]
    },
    {
      id: 190000,
      enabled: roles.includes(190000),
      name: "Daily Quiz",
      icon: <QuizIcon fontSize="small" />,
      path: "/daily-quiz",
      isChild: null,
    },
    {
      id: 450000,
      enabled: roles.includes(450000),
      name: "Blogs",
      icon: <ArticleIcon fontSize="small" />,
      path: "/blog-management",
      isChild: [
        {
          id: 450001,
          enabled: roles.includes(450001),
          name: "Blog Category",
          path: "/blog-management/blog-categories",
        },
        {
          id: 450005,
          enabled: roles.includes(450005),
          name: "Posts",
          path: "/blog-management/posts",
        },
      ],
    },
    {
      id: 200000,
      enabled: roles.includes(200000),
      name: "Lectures Management",
      icon: <FilterFramesIcon fontSize="small" />,
      path: "/lectures-management",
      isChild: null,
    },
    {
      id: 210000,
      enabled: roles.includes(210000),
      name: "Live Lectures",
      icon: <CastForEducationIcon fontSize="small" />,
      path: "/live-lectures",
      isChild: null,
    },
    {
      id: 220000,
      enabled: roles.includes(220000),
      name: "Group Meetings",
      icon: <Groups3Icon fontSize="small" />,
      path: "/group-meetings",
      isChild: null,
    },
    {
      id: 240000,
      enabled: roles.includes(240000),
      name: "Subject Management",
      icon: <SubjectIcon fontSize="small" />,
      path: "/subject-management",
      isChild: [
        {
          id: 240100,
          enabled: roles.includes(240100),
          name: "Subject",
          path: "/subject-management/subject",
        },
        {
          id: 240200,
          enabled: roles.includes(240200),
          name: "Sub Subject",
          path: "/subject-management/sub-subject",
        },
      ],
    },
    // {
    //   id: 666666,
    //   enabled: roles.includes(666666),
    //   name: "Student Test Reports",
    //   icon: <SummarizeIcon fontSize="small" />,
    //   path: "/student-test-report",
    //   isChild: [
    //     // {
    //     //   id: 120100,
    //     //   enabled: roles.includes(120100),
    //     //   name: "Student Admissions",
    //     //   path: "/billing/old-student-admissions",
    //     // },
    //     {
    //       id: 666661,
    //       enabled: roles.includes(666661),
    //       name: "Import Data",
    //       path: "/student-test-report/import-data",
    //     },
    //     {
    //       id: 666662,
    //       enabled: roles.includes(666662),
    //       name: "PSIR Test Students",
    //       path: "/student-test-report/psir-test-students",
    //     },
    //     {
    //       id: 666663,
    //       enabled: roles.includes(666663),
    //       name: "Students Count By Test, Average marks & Percentage",
    //       path: "/student-test-report/students-count",
    //     },
    //     {
    //       id: 666664,
    //       enabled: roles.includes(666664),
    //       name: "Student Attendance Count Report",
    //       path: "/student-test-report/students-attendance-count",
    //     },
    //     {
    //       id: 666665,
    //       enabled: roles.includes(666665),
    //       name: "Student Details Report",
    //       path: "/student-test-report/students-details-report",
    //     },
    //     {
    //       id: 666667,
    //       enabled: roles.includes(666667),
    //       name: "Student Attendance Report",
    //       path: "/student-test-report/students-attendance-report",
    //     },
    //   ],
    // },

    ///////////////////////////////////////

    {
      id: 250000,
      enabled: roles.includes(250000),
      name: "Support",
      icon: <HelpIcon fontSize="small" />,
      path: "/support-management",
      isChild: [
        {
          id: 250100,
          enabled: roles.includes(250100),
          name: "Helps",
          path: "/support-management/helps",
        },
        {
          id: 250200,
          enabled: roles.includes(250200),
          name: "Contact us",
          path: "/support-management/contact",
        },
      ],
    },


    //************************************************** Payment Link Management *************************************************** */ 
    // {
    //   id: 600008,
    //   enabled: roles.includes(600008),
    //   name: "Payments",
    //   icon: <PaymentsIcon fontSize="small" />,
    //   path: "/payments",
    //   isChild: [
    //     {
    //       id: 600009,
    //       enabled: roles.includes(600009),
    //       name: "Payment Links",
    //       path: "/payments/payment-links",
    //     }, {
    //       id: 6000010,
    //       enabled: roles.includes(6000010),
    //       name: "Send Payment Link",
    //       path: "/payments/send-payment-link",
    //     },
    //   ],
    // },

    //************************************************** Payment Refund Management *************************************************** */ 
    // {
    //   id: 520000,
    //   enabled: roles.includes(520000),
    //   name: "Payment Refund Management",
    //   icon: <PaymentsIcon fontSize="small" />,
    //   path: "/payment-refunds",
    //   isChild: [
    //     {
    //       id: 520011,
    //       enabled: roles.includes(520011),
    //       name: "Send Payment Refund Link",
    //       path: "/payment-refunds/send-payment-refund-link",
    //     },
    //     {
    //       id: 520000,
    //       enabled: roles.includes(520000),
    //       name: "Payment Refund Links",
    //       path: "/payment-refunds/payment-refund-links",
    //     }, 
    //     {
    //       id: 520014,
    //       enabled: roles.includes(520014),
    //       name: "Rejected Refunds",
    //       path: "/payment-refunds/rejected-refunds",
    //     },
    //   ],
    // },
  ].filter((side) => side.enabled);

  return sidebarData;
};

export const routes = (roles = []) => {
  const routesData = [
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <Dashboard />,
      path: "/dashboard",
    },

    {
      id: 110001,
      enabled: roles.includes(110001),
      element: <AddStaff />,
      path: "/staff-management/add",
    },
    {
      id: 110002,
      enabled: roles.includes(110002),
      element: <UpdateStaff />,
      path: "/staff-management/update/:id",
    },
    {
      id: 110003,
      enabled: roles.includes(110003),
      element: <SingleStaff />,
      path: "/staff-management/view/:id",
    },
    {
      id: 110000,
      enabled: roles.includes(110000),
      element: <ViewStaffs />,
      path: "/staff-management",
    },

    {
      id: 777125,
      enabled: roles.includes(777125),
      element: <MenuList />,
      path: "/menu-access-management/menu",
    },
    {
      id: 777126,
      enabled: roles.includes(777126),
      element: <AssignedMenus />,
      path: "/menu-access-management/assigned-menus",
    },
    {
      id: 777127,
      enabled: roles.includes(777127),
      element: <AssignedMenu />,
      path: "/menu-access-management/assign-menu",
    },
    {
      id: 2563511,
      enabled: roles.includes(2563511),
      element: <IOSBillingCourse />,
      path: "/course-management/ios-billing-courses",
    },
    {
      id: 120700,
      enabled: roles.includes(120700),
      element: <ViewMappedSubject />,
      path: "/course-management/map-course",
    },

    {
      id: 120800,
      // enabled: roles.includes(120800),
      enabled: false,
      element: <EvaluationPricing />,
      path: "/course-management/evaluation-pricing",
    },
    {
      id: 120811,
      enabled: roles.includes(120811),
      element: <CoursePlatform />,
      path: "/course-management/course-platform",
    },
    {
      id: 120813,
      enabled: roles.includes(120813),
      element: <SpecialExceptionalCourses />,
      path: "/course-management/special-exceptional-courses",
    },
    {
      id: 120813,
      enabled: roles.includes(120813),
      element: <SpecialExceptionStudents />,
      path: "/course-management/special-exceptional-courses/:id/:title",
    },
    {
      id: 120814,
      enabled: roles.includes(120814),
      element: <SpecialExceptionalAccess />,
      path: "/course-management/special-exceptional-access",
    },
    {
      id: 120900,
      enabled: roles.includes(120900),
      element: <MapPostalDocumentsList />,
      path: "/course-management/map-postal-documents-list",
    },
    {
      id: 120904,
      enabled: roles.includes(120904),
      element: <DeletedPostalDocuments />,
      path: "/course-management/deleted-postal-documents-list",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <PostalCourseDocFiles />,
      path: "/course-management/map-postal-documents-list/postal-documents/list/:document/:pagename?",
    },
    {
      id: 120812,
      enabled: roles.includes(120812),
      element: <CoursesLectures />,
      path: "/course-management/courses",
    },
    {
      id: 120301,
      enabled: roles.includes(120301),
      element: <AddCourseCategory />,
      path: "/course-management/course-category/add",
    },
    {
      id: 120302,
      enabled: roles.includes(120302),
      element: <UpdateCourseCategory />,
      path: "/course-management/course-category/update/:id",
    },
    {
      id: 120303,
      enabled: roles.includes(120303),
      element: <SingleCourseCategory />,
      path: "/course-management/course-category/view/:id",
    },
    {
      id: 120300,
      enabled: roles.includes(120300),
      element: <ViewCourseCategory />,
      path: "/course-management/course-category",
    },
    {
      id: 120400,
      enabled: roles.includes(120400),
      element: <ViewSubCategories />,
      path: "/course-management/course-sub-category",
    },
    {
      id: 120201,
      enabled: roles.includes(120201),
      element: <AddCourse />,
      path: "/course-management/courses/add",
    },
    {
      id: 120202,
      enabled: roles.includes(120202),
      element: <UpdateCourse />,
      path: "/course-management/courses/update/:id",
    },
    {
      id: 120200,
      enabled: roles.includes(120200),
      element: <ViewCourses />,
      path: "/course-management/courses",
    },
    {
      id: 120206,
      enabled: roles.includes(120206),
      element: <CourseSectionList />,
      path: "/course-management/courses/:courseId/sections",
    },
    {
      id: 120207,
      enabled: roles.includes(120207),
      element: <CourseLectureList />,
      path: "/course-management/courses/:courseId/lectures",
    },
    {
      id: 120208,
      enabled: roles.includes(120208),
      element: <SectionLectureList />,
      path: "/course-management/courses/:courseId/sections/:sectionId/lectures",
    },
    // student course enquiry
    {
      id: 120208,
      enabled: roles.includes(120208),
      element: <CourseEnquiry />,
      path: "/course-management/course-enquiry",
    },

    // ***************************************** Mentors Course  *****************************************
    {
      id: 652478,
      enabled: roles.includes(652478),
      element: <CourseMentors />,
      path: "/course-management/mentors-course",
    },
    {
      id: 120207,
      enabled: roles.includes(120207),
      element: <CourseLectureList />,
      path: "/course-management/mentors-course/:courseId/lectures",
    },
    {
      id: 652479,
      enabled: roles.includes(652479),
      element: <AssignedMentors />,
      path: "/course-management/mentors-course/assign-mentors/:id/:name",
    },
    {
      id: 310100,
      enabled: roles.includes(310100),
      element: <EvaluationSummary />,
      path: "/evaluation-management/evaluation-summary",
    },


    // **************************** Subject Management  *****************************************
    {
      id: 240100,
      enabled: roles.includes(240100),
      element: <ViewSubjects />,
      path: "/subject-management/subject",
    },
    {
      id: 240200,
      enabled: roles.includes(240200),
      element: <ViewSubSubjects />,
      path: "/subject-management/sub-subject",
    },

    {
      id: 130103,
      enabled: roles.includes(130103),
      element: <SingleStudent />,
      path: "/student-management/assign-course/view/:id",
    },
    {
      id: 130112,
      enabled: roles.includes(130112),
      element: <StudentList />,
      path: "/student-management/all-student-list",
    },
    {
      id: 130100,
      enabled: roles.includes(130100),
      element: <ViewStudents />,
      path: "/student-management/assign-course",
    },
    {
      id: 130107,
      enabled: roles.includes(130107),
      element: <ExceptionalMobileCourses />,
      path: "/student-management/exceptional-mobile-courses",
    },
    {
      id: 130108,
      enabled: roles.includes(130108),
      element: <SpecialLectureAccess />,
      path: "/student-management/personalized-lecture-access",
    },
    {
      id: 130111,
      enabled: roles.includes(130111),
      element: <PersonalizedLectureAccessByCourse />,
      path: "/student-management/personalized-lecture-access-by-course",
    },
    {
      id: 130109,
      enabled: roles.includes(130109),
      element: <StudentPersonalizedLectures />,
      path: "/student-management/student-personalized-lectures",
    },
    {
      id: 130110,
      enabled: roles.includes(130110),
      element: <StudentPersonalizedLecturesbyCourse />,
      path: "/student-management/student-personalized-lectures-by-course",
    },
    // ****************************************** Student Details in Student Management *************************** *************************
    {
      id: 120116,
      enabled: roles.includes(120116),
      element: <SMStudentDetails />,
      path: "/student-management/student-details",
    },
    {
      id: 852369,
      enabled: roles.includes(852369),
      element: <UpdateIFHStudent />,
      path: "/student-management/add-ifh-students",
    },
    {
      id: 120116,
      enabled: roles.includes(120116),
      element: <OnDemandStudentDetails />,
      path: "/student-management/on-demand-student-details",
    },
    {
      id: 564812,
      enabled: roles.includes(564812),
      element: <GPSAccessStudentList />,
      path: "/student-management/gps-courses-student-list",
    },
    {
      id: 130301,
      enabled: roles.includes(130301),
      element: <AddTabCourseAccess />,
      path: "/student-management/tab-course-access/add",
    },
    {
      id: 130300,
      enabled: roles.includes(130300),
      element: <ViewTabCourseAccess />,
      path: "/student-management/tab-course-access",
    },
    {
      id: 130401,
      enabled: roles.includes(130401),
      element: <AddLiveLectureAccess />,
      path: "/student-management/live-lecture-access/add",
    },
    {
      id: 130400,
      enabled: roles.includes(130400),
      element: <ViewLiveLectureAccess />,
      path: "/student-management/live-lecture-access",
    },
    {
      id: 130501,
      enabled: roles.includes(130501),
      element: <AddTabLectureAccess />,
      path: "/student-management/tab-lecture-download-access/add",
    },
    {
      id: 130500,
      enabled: roles.includes(130500),
      element: <ViewTabLectureAccess />,
      path: "/student-management/tab-lecture-download-access/",
    },
    {
      id: 652480,
      enabled: roles.includes(652480),
      element: <CreateUserProfile />,
      path: "/student-management/create-student-profile",
    },
    {
      id: 130600,
      enabled: roles.includes(130600),
      element: <UpdateUserProfile />,
      path: "/student-management/update-profile",
    },

    {
      id: 130600,
      enabled: roles.includes(130600),
      element: <ViewStudentProfile />,
      path: "/student-management/view-profile/:mobile",
    },
    {
      id: 130200,
      enabled: roles.includes(130200),
      element: <CourseWiseStudent />,
      path: "/student-management/course-wise-student/",
    },

    // ********************************** Upgrade Student Course *****************************************
    {
      id: 130106,
      enabled: roles.includes(130106),
      element: <UpgradeStudentCourse />,
      path: "/student-management/upgrade-course",
    },


    {
      id: 200001,
      enabled: roles.includes(200001),
      element: <AddLecture />,
      path: "/lectures-management/add",
    },
    {
      id: 200002,
      enabled: roles.includes(200002),
      element: <UpdateLecture />,
      path: "/lectures-management/update/:id",
    },
    {
      id: 200000,
      enabled: roles.includes(200000),
      element: <ViewLectures />,
      path: "/lectures-management",
    },
    {
      id: 210001,
      enabled: roles.includes(210001),
      element: <AddLiveLecture />,
      path: "/live-lectures/add",
    },
    {
      id: 210002,
      enabled: roles.includes(210002),
      element: <UpdateLiveLecture />,
      path: "/live-lectures/update/:id",
    },
    {
      id: 210000,
      enabled: roles.includes(210000),
      element: <ViewLiveLectures />,
      path: "/live-lectures",
    },
    {
      id: 220001,
      enabled: roles.includes(220001),
      element: <AddGroupMeeting />,
      path: "/group-meetings/add",
    },
    {
      id: 220002,
      enabled: roles.includes(220002),
      element: <UpdateGroupMeeting />,
      path: "/group-meetings/update/:id",
    },
    {
      id: 9658546,
      enabled: roles.includes(9658546),
      element: <MobileNumber />,
      path: "/verify-mobile",
    },

    {
      id: 9658547,
      enabled: roles.includes(9658547),
      element: <SamplePage />,
      path: "/sample",
    },
    {
      id: 220000,
      enabled: roles.includes(220000),
      element: <ViewGroupMeetings />,
      path: "/group-meetings",
    },
    {
      id: 140100,
      enabled: roles.includes(140100),
      element: <AllTestListing />,
      path: "/test-management/test",
    },
    {
      id: 890003,
      enabled: roles.includes(890003),
      element: <AffiliateMacId />,
      path: "/affiliate-macids",
    },
    {
      id: 140101,
      enabled: roles.includes(140101),
      element: <AddTest />,
      path: "/test-management/test/add",
    },
    {
      id: 140102,
      enabled: roles.includes(140102),
      element: <UpdateTest />,
      path: "/test-management/test/update/:id",
    },
    {
      id: 140106,
      enabled: roles.includes(140106),
      element: <QuestionList />,
      path: "/test-management/test/:id",
    },
    {
      id: 140107,
      enabled: roles.includes(140107),
      element: <AddQuestion />,
      path: "/test-management/test/:id/add",
    },
    {
      id: 140108,
      enabled: roles.includes(140108),
      element: <UpdateQuestion />,
      path: "/test-management/test/:id/update/:questionId",
    },
    {
      id: 140200,
      enabled: roles.includes(140200),
      element: <TestBankListing />,
      path: "/test-management/test-bank",
    },
    {
      id: 140400,
      enabled: roles.includes(140400),
      element: <MapTestToCourses />,
      path: "/test-management/map-test-to-courses",
    },
    {
      id: 140300,
      enabled: roles.includes(140300),
      element: <ArtifactMappingList />,
      path: "/test-management/artifacts-mapping",
    },
    {
      id: 160100,
      enabled: roles.includes(160100),
      element: <ViewFaqs />,
      path: "/bank-management/faqs",
    },
    {
      id: 160101,
      enabled: roles.includes(160101),
      element: <AddFaqs />,
      path: "/bank-management/faqs/add",
    },
    {
      id: 160102,
      enabled: roles.includes(160102),
      element: <UpdateFaqs />,
      path: "/bank-management/faqs/update/:id",
    },
    {
      id: 160200,
      enabled: roles.includes(160200),
      element: <ViewCoreTakeaway />,
      path: "/bank-management/core-takeaway",
    },
    {
      id: 160201,
      enabled: roles.includes(160201),
      element: <AddCoreTakeaway />,
      path: "/bank-management/core-takeaway/add",
    },
    {
      id: 160202,
      enabled: roles.includes(160202),
      element: <UpdateCoreTakeaway />,
      path: "/bank-management/core-takeaway/update/:id",
    },
    // {
    //   enabled: false,
    //   element: <ViewMasterVideoBank />,
    //   path: "/bank-management/video-bank",
    // },
    // {
    //   enabled: false,
    //   element: <AddMasterVideoBank />,
    //   path: "/bank-management/video-bank/add",
    // },
    // {
    //   enabled: false,
    //   element: <UpdateMasterVideoBank />,
    //   path: "/bank-management/video-bank/update/:id",
    // },
    {
      id: 160300,
      enabled: roles.includes(160300),
      element: <ViewWebsiteVideoBank />,
      path: "/bank-management/website-video-bank",
    },
    {
      id: 160301,
      enabled: roles.includes(160301),
      element: <AddWebsiteVideoBank />,
      path: "/bank-management/website-video-bank/add",
    },
    {
      id: 160302,
      enabled: roles.includes(160302),
      element: <UpdateWebsiteVideoBank />,
      path: "/bank-management/website-video-bank/update/:id",
    },
    {
      id: 250200,
      enabled: roles.includes(250200),
      element: <ViewContact />,
      path: "/support-management/contact",
    },
    {
      id: 250100,
      enabled: roles.includes(250100),
      element: <ViewHelps />,
      path: "/support-management/helps",
    },

    {
      id: 190002,
      enabled: roles.includes(190002),
      element: <UpdateQuiz />,
      path: "/daily-quiz/update/:id",
    },
    {
      id: 450001,
      enabled: roles.includes(450001),
      element: <BlogCategory />,
      path: "/blog-management/blog-categories",
    },
    {
      id: 450005,
      enabled: roles.includes(450005),
      element: <Posts />,
      path: "/blog-management/posts",
    },
    {
      id: 450006,
      enabled: roles.includes(450006),
      element: <AddPost />,
      path: "/blog-management/posts/add-post",
    },
    {
      id: 450007,
      enabled: roles.includes(450007),
      element: <UpdatePost />,
      path: "/blog-management/posts/update-post/:id?",
    },
    {
      id: 450011,
      enabled: roles.includes(450011),
      element: <PostComments />,
      path: "/blog-management/post-comments/:postid/:posttitle?",
    },

    {
      id: 320000,
      enabled: roles.includes(320000),
      element: <Permissions />,
      path: "/permissions",
    },
    {
      id: 320000,
      enabled: roles.includes(320000),
      element: <AddKnoxTabletStudents />,
      path: "/add-knox-exception",
    },
    {
      id: 5124896,
      enabled: roles.includes(5124896),
      element: <StudentCourseTestReport />,
      path: "/student-course-test-report",
    },
    {
      id: 9658547,
      enabled: roles.includes(9658547),
      element: <AddOldStudentDetail />,
      path: "/add-old-student-details",
    },
    {
      id: 9658500,
      enabled: roles.includes(9658500),
      element: <CourseAccessReport />,
      path: "/course-access-reports",
    },
    {
      id: 652472,
      enabled: roles.includes(652472),
      element: <StudentKYCDetails />,
      path: "/kyc-management/student-kyc-details",
    },
    {
      id: 652475,
      enabled: roles.includes(652475),
      element: <KYCVerifiedByStudentList />,
      path: "/kyc-management/kyc-verified-student",
    },
    {
      id: 652473,
      enabled: roles.includes(652473),
      element: <VerifiedKYCList />,
      path: "/kyc-management/verified-kyc-list",
    },
    {
      id: 652473,
      enabled: roles.includes(652473),
      element: <StudentKYCAction />,
      path: "/kyc-management/student-kyc-action/:mobile",
    },
    {
      id: 652474,
      enabled: roles.includes(652474),
      element: <RequestedKYCList />,
      path: "/kyc-management/requested-kyc-list",
    },
    {
      id: 996612,
      enabled: roles.includes(996612),
      element: <PGMaster />,
      path: "/pg-management/pg-master",
    },
    {
      id: 996613,
      enabled: roles.includes(996613),
      element: <AddPGMaster />,
      path: "/pg-management/pg-master/add-pg-master",
    },
    {
      id: 996614,
      enabled: roles.includes(996614),
      element: <EditPGMaster />,
      path: "/pg-management/pg-master/edit-pg-master/:id",
    },
    {
      id: 996616,
      enabled: roles.includes(996616),
      element: <AffiliatePG />,
      path: "/pg-management/affiliate-pg",
    },
    {
      enabled: true,
      element: <ChangePassword />,
      path: "/change-password",
    },
    // ******************************* Exceptional Lecture Management ***************************************
    {
      id: 150000,
      enabled: roles.includes(150000),
      element: <ExceptionalLectures />,
      path: "/exceptional-lecture-management",
    },
    {
      id: 190000,
      enabled: roles.includes(190000),
      element: <ViewQuizs />,
      path: "/daily-quiz",
    },
    {
      id: 190000,
      enabled: roles.includes(190000),
      element: <ViewQuizs />,
      path: "/daily-quiz",
    },
    {
      id: 190001,
      enabled: roles.includes(190001),
      element: <AddQuiz />,
      path: "/daily-quiz/add",
    },
    {
      id: 190002,
      enabled: roles.includes(190002),
      element: <UpdateQuiz />,
      path: "/daily-quiz/update/:id",
    },


  ].filter((route) => route.enabled);
  return routesData;
};
